import { render } from "./ModalSecurityObject.vue?vue&type=template&id=e1347c62&scoped=true"
import script from "./ModalSecurityObject.vue?vue&type=script&lang=js"
export * from "./ModalSecurityObject.vue?vue&type=script&lang=js"

import "./ModalSecurityObject.vue?vue&type=style&index=0&id=e1347c62&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1347c62"]])

export default __exports__